import { gql } from '@apollo/client'

export const ASSIGN_BROADSIGN_CREATION_MEDIA = gql`
  mutation AssignBroadsignCreationMedia($id: ID!, $buildings: [BroadsignCreationBuildingUsage!]!) {
    assignBroadsignCreationMedia(input: { id: $id, buildings: $buildings }) {
      broadsignCreation {
        id
        usedBuildingsNotSentCount
      }
      errors
      success
    }
  }
`
